<section class="achievements-section">

  <div class="container">

    <div class="section-header">
      <!-- <span class="badge">
        Excellence & Achievements
      </span> -->

      <h2>
        Celebrating Success Stories
      </h2>

      <p>
        Our students continue to excel in academics, sports, and
        co-curricular activities, setting benchmarks of excellence year after year.
      </p>
    </div>

    <!-- Stats -->

    <!-- <div class="stats-grid">

      <div
        class="stat-card"
        *ngFor="let stat of stats"
      >
        <h3>{{ stat.value }}</h3>
        <span>{{ stat.label }}</span>
      </div>

    </div> -->

    <!-- Toppers -->

    <div class="toppers-wrapper">

      <div
        class="topper-card"
        *ngFor="let topper of toppers"
      >

        <div class="image-wrapper">
          <img
            [src]="topper.imageUrl"
            [alt]="topper.title"
          >
          <!-- <div class="score-badge">
            {{ topper.percentage }}
          </div> -->
        </div>

        <!-- <div class="content">
          <h4>{{ topper.name }}</h4>
          <p>{{ topper.className }}</p>
        </div> -->

      </div>

    </div>

    <!-- Highlights -->
    <!-- <div class="achievement-highlights">
      <div
        class="highlight-item"
        *ngFor="let item of highlights"
      >
        ✓ {{ item }}
      </div>
    </div> -->

  </div>

</section>